angular.module('impactx.requestItem').directive('ixRequestItemPopupAttributeLine', function ()
{
    return {
        scope: {
            attribute: "="
        },
        restrict: 'A',
        templateUrl: 'shared/requestitem/templates/requestitemattributepopupline.tmpl.html'
    };
});